import {
  setProfilesPortsData,
  createProfilesPort,
  updateProfilesPort,
  deleteProfilesPort,
} from "stores/slice/bogus/profiles/ports/const";

import {
  setMacAddressesData,
  createMacAddressProfile,
  updateMacAddressProfile,
  deleteMacAddressProfile,
} from "stores/slice/bogus/profiles/macAddress/const";

import {
  setIpAddressesData,
  createIpAddressProfile,
  updateIpAddressProfile,
  deleteIpAddressProfile,
} from "stores/slice/bogus/profiles/ipAddress/const";

import {
  setUserAccountProfilesData,
  createUserAccountProfile,
  updateUserAccountProfile,
  deleteUserAccountProfile,
} from "stores/slice/bogus/profiles/userAccount/const";

import {
  createProfilesRadiusServer,
  updateProfilesRadiusServer,
  deleteProfilesRadiusServer,
} from 'stores/slice/bogus/profiles/radiusServer/const';

import {
  setScheduleProfilesData,
  setScheduleProfileData,
  createScheduleProfile,
  updateScheduleProfile,
  deleteScheduleProfile,
} from "stores/slice/bogus/profiles/schedule/const";

import {
  createProfilesLdapServer,
  updateProfilesLdapServer,
  deleteProfilesLdapServer,
} from 'stores/slice/bogus/profiles/ldapServer/const';

const profilesConfig = {
  // Profile Ports
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profilePorts.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profilePorts",
    restful: true,
    method: "read",
    buildParams: (params) => ({ data: params }),
    action: setProfilesPortsData,
    mockSelector: "profilesPorts",
  },
  "/orgs/:orgId/sites/:siteId/settings/profilePorts.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profilePorts",
    restful: true,
    method: "read",
    buildParams: (params) => ({ data: params }),
    action: setProfilesPortsData,
    mockSelector: "profilesPorts",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profilePorts.create": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profilePorts",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params }),
    action: createProfilesPort,
    mockSelector: "profilesPorts",
  },
  "/orgs/:orgId/sites/:siteId/settings/profilePorts.create": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profilePorts",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params }),
    action: createProfilesPort,
    mockSelector: "profilesPorts",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profilePorts/:portId/profilePorts.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profilePorts/:portId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: updateProfilesPort,
    mockSelector: "profilesPorts",
  },
  "/orgs/:orgId/sites/:siteId/settings/profilePorts/:portId/profilePorts.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profilePorts/:portId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: updateProfilesPort,
    mockSelector: "profilesPorts",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profilePorts/:portId/profilePorts.delete": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profilePorts/:portId",
    restful: true,
    method: "delete",
    buildParams: (params) => ({ data: params }),
    action: deleteProfilesPort,
    mockSelector: "profilesPorts",
  },
  "/orgs/:orgId/sites/:siteId/settings/profilePorts/:portId/profilePorts.delete": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profilePorts/:portId",
    restful: true,
    method: "delete",
    buildParams: (params) => ({ data: params }),
    action: deleteProfilesPort,
    mockSelector: "profilesPorts",
  },
  // Profile Schedule
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileSchedule.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileSchedule",
    restful: true,
    method: "read",
    action: setScheduleProfilesData,
    mockSelector: "profilesSchedule",
  },
  "/orgs/:orgId/sites/:siteId/settings/profileSchedule.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profileSchedule",
    restful: true,
    method: "read",
    action: setScheduleProfilesData,
    mockSelector: "profilesSchedule",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileSchedule/:profileScheduleId.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileSchedule/:profileScheduleId",
    restful: true,
    method: "read",
    action: setScheduleProfileData,
    mockSelector: "profilesSchedule",
  },
  "/orgs/:orgId/sites/:siteId/settings/profileSchedule/:profileScheduleId.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profileSchedule/:profileScheduleId",
    restful: true,
    method: "read",
    action: setScheduleProfileData,
    mockSelector: "profilesSchedule",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileSchedule.create": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileSchedule",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params }),
    action: createScheduleProfile,
    mockSelector: "profilesSchedule",
  },
  "/orgs/:orgId/sites/:siteId/settings/profileSchedule.create": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profileSchedule",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params }),
    action: createScheduleProfile,
    mockSelector: "profilesSchedule",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileSchedule/:profileScheduleId.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileSchedule/:profileScheduleId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: updateScheduleProfile,
    mockSelector: "profilesSchedule",
  },
  "/orgs/:orgId/sites/:siteId/settings/profileSchedule/:profileScheduleId.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profileSchedule/:profileScheduleId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: updateScheduleProfile,
    mockSelector: "profilesSchedule",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileSchedule.delete": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileSchedule",
    restful: true,
    method: "delete",
    buildParams: (params) => ({ data: params }),
    action: deleteScheduleProfile,
    mockSelector: "profilesSchedule",
  },
  "/orgs/:orgId/sites/:siteId/settings/profileSchedule.delete": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profileSchedule",
    restful: true,
    method: "delete",
    buildParams: (params) => ({ data: params }),
    action: deleteScheduleProfile,
    mockSelector: "profilesSchedule",
  },
  // Profile MAC Addresses
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileMacAddrs.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileMacAddrs",
    restful: true,
    method: "read",
    buildParams: (params) => ({ data: params }),
    action: setMacAddressesData,
    mockSelector: "profilesMacAddress",
  },
  "/ents/:entId/sites/:siteId/settings/profileMacAddrs.read": {
    protocol: "ws",
    resource: "/ents/:entId/sites/:siteId/settings/profileMacAddrs",
    restful: true,
    method: "read",
    buildParams: (params) => ({ data: params }),
    action: setMacAddressesData,
    mockSelector: "profilesMacAddress",
  },
  "/orgs/:orgId/sites/:siteId/settings/profileMacAddrs.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profileMacAddrs",
    restful: true,
    method: "read",
    buildParams: (params) => ({ data: params }),
    action: setMacAddressesData,
    mockSelector: "profilesMacAddress",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileMacAddrs.create": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileMacAddrs",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params }),
    action: createMacAddressProfile,
    mockSelector: "profilesMacAddress",
  },
  "/ents/:entId/sites/:siteId/settings/profileMacAddrs.create": {
    protocol: "ws",
    resource: "/ents/:entId/sites/:siteId/settings/profileMacAddrs",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params }),
    action: createMacAddressProfile,
    mockSelector: "profilesMacAddress",
  },
  "/orgs/:orgId/sites/:siteId/settings/profileMacAddrs.create": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profileMacAddrs",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params }),
    action: createMacAddressProfile,
    mockSelector: "profilesMacAddress",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileMacAddrs/:macGroupId/profileMacAddrs.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileMacAddrs/:macGroupId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: updateMacAddressProfile,
    mockSelector: "profilesMacAddress",
  },
  "/ents/:entId/sites/:siteId/settings/profileMacAddrs/:macGroupId/profileMacAddrs.update": {
    protocol: "ws",
    resource: "/ents/:entId/sites/:siteId/settings/profileMacAddrs/:macGroupId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: updateMacAddressProfile,
    mockSelector: "profilesMacAddress",
  },
  "/orgs/:orgId/sites/:siteId/settings/profileMacAddrs/:macGroupId/profileMacAddrs.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profileMacAddrs/:macGroupId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: updateMacAddressProfile,
    mockSelector: "profilesMacAddress",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileMacAddrs.delete": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileMacAddrs",
    restful: true,
    method: "delete",
    buildParams: (params) => ({ data: params }),
    action: deleteMacAddressProfile,
    mockSelector: "profilesMacAddress",
  },
  "/ents/:entId/:orgs/:orgId/sites/:siteId/settings/profileMacAddrs.delete": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/{orgId}/sites/{siteId}/settings/profileMacAddrs",
    restful: true,
    method: "delete",
    buildParams: (params) => ({ data: params }),
    action: deleteMacAddressProfile,
    mockSelector: "profilesMacAddress",
  },
  "/orgs/:orgId/sites/:siteId/settings/profileMacAddrs.delete": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profileMacAddrs",
    restful: true,
    method: "delete",
    buildParams: (params) => ({ data: params }),
    action: deleteMacAddressProfile,
    mockSelector: "profilesMacAddress",
  },
  // Profile IP Addresses
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileIpAddrs.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileIpAddrs",
    restful: true,
    method: "read",
    buildParams: (params) => ({ data: params }),
    action: setIpAddressesData,
    mockSelector: "profilesIpAddress",
  },
  "/orgs/:orgId/sites/:siteId/settings/profileIpAddrs.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profileIpAddrs",
    restful: true,
    method: "read",
    buildParams: (params) => ({ data: params }),
    action: setIpAddressesData,
    mockSelector: "profilesIpAddress",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileIpAddrs.create": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileIpAddrs",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params }),
    action: createIpAddressProfile,
    mockSelector: "profilesIpAddress",
  },
  "/orgs/:orgId/sites/:siteId/settings/profileIpAddrs.create": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profileIpAddrs",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params }),
    action: createIpAddressProfile,
    mockSelector: "profilesIpAddress",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileIpAddrs/:profileIpAddrsId.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileIpAddrs/:profileIpAddrsId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: updateIpAddressProfile,
    mockSelector: "profilesIpAddress",
  },
  "/orgs/:orgId/sites/:siteId/settings/profileIpAddrs/:profileIpAddrsId.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profileIpAddrs/:profileIpAddrsId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: updateIpAddressProfile,
    mockSelector: "profilesIpAddress",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileIpAddrs.delete": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileIpAddrs",
    restful: true,
    method: "delete",
    buildParams: (params) => ({ data: params }),
    action: deleteIpAddressProfile,
    mockSelector: "profilesIpAddress",
  },
  "/orgs/:orgId/sites/:siteId/settings/profileIpAddrs.delete": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profileIpAddrs",
    restful: true,
    method: "delete",
    buildParams: (params) => ({ data: params }),
    action: deleteIpAddressProfile,
    mockSelector: "profilesIpAddress",
  },
  // Profile User Accounts
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileUserAccounts.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileUserAccounts",
    restful: true,
    method: "read",
    buildParams: (params) => ({ data: params }),
    action: setUserAccountProfilesData,
    mockSelector: "profilesUserAccount",
  },
  "/orgs/:orgId/sites/:siteId/settings/profileUserAccounts.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profileUserAccounts",
    restful: true,
    method: "read",
    buildParams: (params) => ({ data: params }),
    action: setUserAccountProfilesData,
    mockSelector: "profilesUserAccount",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileUserAccounts.create": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileUserAccounts",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params }),
    action: createUserAccountProfile,
    mockSelector: "profilesUserAccount",
  },
  "/orgs/:orgId/sites/:siteId/settings/profileUserAccounts.create": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profileUserAccounts",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params }),
    action: createUserAccountProfile,
    mockSelector: "profilesUserAccount",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileUserAccounts/:profileUserAccountsId.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileUserAccounts/:profileUserAccountsId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: updateUserAccountProfile,
    mockSelector: "profilesUserAccount",
  },
  "/orgs/:orgId/sites/:siteId/settings/profileUserAccounts/:profileUserAccountsId.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profileUserAccounts/:profileUserAccountsId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: updateUserAccountProfile,
    mockSelector: "profilesUserAccount",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileUserAccounts.delete": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileUserAccounts",
    restful: true,
    method: "delete",
    buildParams: (params) => ({ data: params }),
    action: deleteUserAccountProfile,
    mockSelector: "profilesUserAccount",
  },
  "/orgs/:orgId/sites/:siteId/settings/profileUserAccounts.delete": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profileUserAccounts",
    restful: true,
    method: "delete",
    buildParams: (params) => ({ data: params }),
    action: deleteUserAccountProfile,
    mockSelector: "profilesUserAccount",
  },
  // Profile Radius Server
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/radiusProfile.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/radiusProfile",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "profilesRadiusServer",
  },
  "/orgs/:orgId/sites/:siteId/settings/radiusProfile.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/radiusProfile",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "profilesRadiusServer",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/radiusProfile.create": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/radiusProfile",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params }),
    action: createProfilesRadiusServer,
    mockSelector: "profilesRadiusServer",
  },
  "/orgs/:orgId/sites/:siteId/settings/radiusProfile.create": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/radiusProfile",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params }),
    action: createProfilesRadiusServer,
    mockSelector: "profilesRadiusServer",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/radiusProfile/:radiusId.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/radiusProfile/:radiusId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: updateProfilesRadiusServer,
    mockSelector: "profilesRadiusServer",
  },
  "/orgs/:orgId/sites/:siteId/settings/radiusProfile/:radiusId.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/radiusProfile/:radiusId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: updateProfilesRadiusServer,
    mockSelector: "profilesRadiusServer",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/radiusProfile.delete": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/radiusProfile",
    restful: true,
    method: "delete",
    buildParams: (params) => ({ data: params }),
    action: deleteProfilesRadiusServer,
    mockSelector: "profilesRadiusServer",
  },
  "/orgs/:orgId/sites/:siteId/settings/radiusProfile.delete": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/radiusProfile",
    restful: true,
    method: "delete",
    buildParams: (params) => ({ data: params }),
    action: deleteProfilesRadiusServer,
    mockSelector: "profilesRadiusServer",
  },
  // Profile LDAP Server
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileLdap.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileLdap",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "profilesLdapServer",
  },
  "/orgs/:orgId/sites/:siteId/settings/profileLdap.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profileLdap",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "profilesLdapServer",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileLdap.create": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileLdap",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params }),
    action: createProfilesLdapServer,
    mockSelector: "profilesLdapServer",
  },
  "/orgs/:orgId/sites/:siteId/settings/profileLdap.create": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profileLdap",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params }),
    action: createProfilesLdapServer,
    mockSelector: "profilesLdapServer",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileLdap/:ldapId.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileLdap/:ldapId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: updateProfilesLdapServer,
    mockSelector: "profilesLdapServer",
  },
  "/orgs/:orgId/sites/:siteId/settings/profileLdap/:ldapId.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profileLdap/:ldapId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: updateProfilesLdapServer,
    mockSelector: "profilesLdapServer",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileLdap.delete": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileLdap",
    restful: true,
    method: "delete",
    buildParams: (params) => ({ data: params }),
    action: deleteProfilesLdapServer,
    mockSelector: "profilesLdapServer",
  },
  "/orgs/:orgId/sites/:siteId/settings/profileLdap.delete": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profileLdap",
    restful: true,
    method: "delete",
    buildParams: (params) => ({ data: params }),
    action: deleteProfilesLdapServer,
    mockSelector: "profilesLdapServer",
  },
};

export default profilesConfig;
